<template>
  <div class="container">
    <!--
      Dummy Image
      Replacement is necessary after obtaining advertisement information.
    -->
    <div class="row h-100">
      <div id="adDiv" class="col-auto flex-md-fill"  style="margin: 16px; color: white; background-color: #ffffff; text-align: center;"
      :style="isMobile() ? 'margin:0; width:100%;':''">
          <!-- <p style="margin-top: 15%;">ここに広告が入ります。</p> -->
          <div id="ad_area_1" class="mb-3"></div>
          <div id="ad_area_2"></div>
          <div id="ad_area_3" class="d-block d-sm-none mb-3"></div>
          <div id="ad_area_4" class="d-block d-sm-none"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import postscribe from 'postscribe';

  export default {
    name: "AdvertisementPage",
    mounted() {
      const AD1 = `
      <script type="text/javascript">
      var adstir_vars = {
        ver: "4.0",
        app_id: "MEDIA-b4803553",
        ad_spot: 1,
        center: false
      };
      <\/script>
      <script src="https://js.ad-stir.com/js/adstir.js"><\/script>`

      const AD2 = `
      <script type="text/javascript">
      var adstir_vars = {
        ver: "4.0",
        app_id: "MEDIA-b4803553",
        ad_spot: 2,
        center: false
      };
      <\/script>
      <script src="https://js.ad-stir.com/js/adstir.js"><\/script>`

      const AD3 = `
      <script type="text/javascript">
      var adstir_vars = {
        ver: "4.0",
        app_id: "MEDIA-f2c05787",
        ad_spot: 1,
        center: false
      };
      <\/script>
      <script src="https://js.ad-stir.com/js/adstir.js"><\/script>`

      const AD4 = `
      <script type="text/javascript">
      var adstir_vars = {
        ver: "4.0",
        app_id: "MEDIA-f2c05787",
        ad_spot: 2,
        center: false
      };
      <\/script>
      <script src="https://js.ad-stir.com/js/adstir.js"><\/script>`

      if (!this.isMobile()) {
        postscribe('#ad_area_1', AD1)
        postscribe('#ad_area_2', AD2)
      } else {
        postscribe('#ad_area_3', AD3)
        postscribe('#ad_area_4', AD4)
      }
    }
  }

</script>

<style scoped>
  .container {
    background-color: white;
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/AdvertisementPage.vue